import { useEffect } from 'react';
import { atom, useRecoilState } from 'recoil';
import { ConversationDetailsTabs } from 'modules/conversations/constants/conversationDetailsTabs';

export const conversationDetailsTabAtom = atom<ConversationDetailsTabs>({
  key: 'conversationDetailsTabAtom',
  default: ConversationDetailsTabs.ConversationDetails
});

export const useConversationDetailsTab = ({
  onTabChange
}: {
  onTabChange?: (tab: ConversationDetailsTabs) => void;
} = {}) => {
  const [selectedTab, setSelectedTab] = useRecoilState(
    conversationDetailsTabAtom
  );

  useEffect(() => {
    if (onTabChange) {
      onTabChange(selectedTab);
    }
  }, [selectedTab]);

  return {
    selectedTab,
    setSelectedTab
  };
};
